export * from './regex';
export * from './style';
export * from './config';
export * from './translation';
export * from './pushAction';
export * from './recaptcha';
export * from './utm';

export const BREAKLINE_CHAR = String.fromCharCode(10);
